import { NavioLicensePlate } from '../CarDetails/Cards/NavioLicensePlate';
import type { CarGroup } from './notificationGroupTypes';
import type { NotificationGroupOverviewTranslations } from './notificationTranslations';

/** Capped: a fleet member can drive dozens of cars, and the full list would push the rest of the sheet past the fold on a phone. */
const PREVIEW_COUNT = 5;

type Props = {
  cars: CarGroup[];
  totalCount: number;
  translations: NotificationGroupOverviewTranslations;
};

export const DrivenCarsList = ({ cars, totalCount, translations: t }: Props) => {
  if (cars.length === 0) {
    return (
      <div className='flex flex-col gap-1 rounded-xl border border-dashed border-muted-foreground/40 p-3 text-sm'>
        <p className='font-medium'>{t.noDrivenCars}</p>
        <p className='text-muted-foreground'>{t.noDrivenCarsDescription}</p>
      </div>
    );
  }

  return (
    <ul className='flex flex-col gap-2'>
      {cars.slice(0, PREVIEW_COUNT).map((car) => (
        <li
          key={car.userGroupCarId}
          className='flex min-w-0 items-center justify-between gap-3 rounded-xl border border-border/60 px-3 py-2 text-sm'
        >
          <span className='min-w-0 truncate font-medium'>{`${car.make} ${car.model}`}</span>
          <NavioLicensePlate car={{ licensePlateNumber: car.licensePlate.number }} className='shrink-0' />
        </li>
      ))}
      {totalCount > PREVIEW_COUNT && (
        <li className='px-3 text-sm text-muted-foreground'>{t.moreCars(totalCount - PREVIEW_COUNT)}</li>
      )}
    </ul>
  );
};
